import { useState, useEffect } from 'react'
import { C } from '../theme'
import { optIn, optOut } from '../lib/posthog'

const CONSENT_KEY = 'netefy-cookie-consent'

type ConsentState = 'pending' | 'accepted' | 'declined'

export function getCookieConsent(): ConsentState {
  if (typeof window === 'undefined') return 'pending'
  const val = localStorage.getItem(CONSENT_KEY)
  if (val === 'accepted') return 'accepted'
  if (val === 'declined') return 'declined'
  return 'pending'
}

export function CookieConsent() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const consent = getCookieConsent()
    if (consent === 'pending') {
      setVisible(true)
    }
  }, [])

  function handleAccept() {
    localStorage.setItem(CONSENT_KEY, 'accepted')
    optIn()
    setVisible(false)
  }

  function handleDecline() {
    localStorage.setItem(CONSENT_KEY, 'declined')
    optOut()
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 100,
      background: `${C.panel}ee`,
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      borderTop: `1px solid ${C.border}`,
      padding: '16px 24px',
    }}>
      <div style={{
        maxWidth: 1200,
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        flexWrap: 'wrap',
      }}>
        <p style={{
          fontFamily: C.sans,
          fontSize: 13,
          color: C.muted,
          lineHeight: 1.5,
          margin: 0,
          flex: '1 1 400px',
        }}>
          We use essential cookies for authentication and security. Optional analytics via PostHog (EU region, cookie-free).
          No tracking cookies. No third-party advertising.{' '}
          <a href="/legal" style={{ color: C.accent, textDecoration: 'none' }}>Privacy Policy</a>
        </p>
        <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
          <button
            onClick={handleDecline}
            style={{
              fontFamily: C.mono,
              fontSize: 12,
              fontWeight: 500,
              color: C.muted,
              background: 'transparent',
              border: `1px solid ${C.border}`,
              borderRadius: 4,
              padding: '6px 14px',
              cursor: 'pointer',
            }}
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            style={{
              fontFamily: C.mono,
              fontSize: 12,
              fontWeight: 600,
              color: C.bg,
              background: C.accent,
              border: 'none',
              borderRadius: 4,
              padding: '6px 14px',
              cursor: 'pointer',
            }}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  )
}
